<mat-toolbar>
    @if (siteConfig$ | async; as siteConfig) {
        <button mat-button routerLink="/s/{{ siteConfig.data.primary_stream }}">
            <mat-icon>exit_to_app</mat-icon>
            Back to Streams
        </button>
    }
</mat-toolbar>
@if ({ params: routeParams$ | async, user: user$ | async }; as observables) {
    @if (observables.user?.hasPermission("frog_multitenant.change_clientconfig")) {
        <mat-drawer-container class="container">
            <mat-drawer mode="side" opened>
                <mat-selection-list
                    [multiple]="false"
                    [hideSingleSelectionIndicator]="true"
                    (selectionChange)="changeTabs($event)"
                >
                    <mat-list-option value="">
                        <mat-icon matListItemIcon>dashboard</mat-icon>
                        Dashboard
                    </mat-list-option>
                    @if (observables.user.hasPermission("frog.change_tag")) {
                        <mat-list-option [selected]="observables.params.tab === 'tag'" value="tag">
                            <mat-icon matListItemIcon>label</mat-icon>
                            Tags
                        </mat-list-option>
                    }
                    @if (observables.user.hasPermission("frog_auth.change_user")) {
                        <mat-list-option
                            [selected]="observables.params.tab === 'billing'"
                            value="billing"
                        >
                            @if (hosted) {
                                <ng-container>
                                    <mat-icon matListItemIcon>person</mat-icon>
                                    Users
                                </ng-container>
                            } @else {
                                <ng-container>
                                    <mat-icon matListItemIcon>account_balance</mat-icon>
                                    Billing
                                </ng-container>
                            }
                        </mat-list-option>
                    }
                    @if (observables.user.hasPermission("frog.change_asset")) {
                        <mat-list-option
                            [selected]="observables.params.tab === 'content'"
                            value="content"
                        >
                            <mat-icon matListItemIcon>photo_library</mat-icon>
                            Content
                        </mat-list-option>
                    }
                    @if (observables.user.hasPermission("frog.change_asset")) {
                        <mat-list-option
                            [selected]="observables.params.tab === 'stream'"
                            value="stream"
                        >
                            <mat-icon matListItemIcon>water</mat-icon>
                            Streams
                        </mat-list-option>
                    }
                </mat-selection-list>
            </mat-drawer>
            <mat-drawer-content>
                <div class="container">
                    @if (
                        observables.user.hasPermission("frog_multitenant.change_clientconfig") &&
                        !(client$ | async)?.is_paid
                    ) {
                        <div>
                            <frog-upgrade-card></frog-upgrade-card>
                        </div>
                    }
                    @switch (observables.params.tab) {
                        @case ("content") {
                            <frog-content-admin></frog-content-admin>
                        }
                        @case ("billing") {
                            <frog-billing-admin></frog-billing-admin>
                        }
                        @case ("tag") {
                            <frog-tag-admin></frog-tag-admin>
                        }
                        @case ("stream") {
                            <frog-stream-admin></frog-stream-admin>
                        }
                        <!-- Dashboard -->
                        @default {
                            <div class="flex row flex-wrap">
                                @if (
                                    observables.user.hasPermission(
                                        "frog_multitenant.change_clientconfig"
                                    )
                                ) {
                                    <div class="flex-100 container">
                                        <frog-site-card></frog-site-card>
                                    </div>
                                }
                                <div class="flex row">
                                    @if (observables.user.hasPermission("frog.change_tag")) {
                                        <div class="flex-50 container">
                                            <frog-tags-card></frog-tags-card>
                                        </div>
                                    }
                                    <div class="flex-50 container">
                                        <frog-badge-card></frog-badge-card>
                                    </div>
                                </div>
                                @if (!hosted) {
                                    @if (observables.user.hasPermission("frog.change_asset")) {
                                        <div class="flex-100 container">
                                            <frog-content-card></frog-content-card>
                                        </div>
                                    }
                                    @if (observables.user.hasPermission("frog_auth.change_user")) {
                                        <div class="flex-100 container">
                                            <frog-users-card></frog-users-card>
                                        </div>
                                    }
                                }
                                @if (
                                    observables.user.hasPermission("frog_multitenant.change_client")
                                ) {
                                    <div class="flex-100 container">
                                        <frog-access-token-card></frog-access-token-card>
                                    </div>
                                }
                                @if (
                                    observables.user.hasPermission("frog_multitenant.change_client")
                                ) {
                                    <div class="flex-100 container">
                                        <frog-delete-card></frog-delete-card>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
                @if (client$ | async; as client) {
                    <div class="client-info">
                        <small>{{ client.id }} | {{ client.name }}</small>
                    </div>
                }
                <div class="client-info">
                    <small>{{ appVersion }}</small>
                </div>
            </mat-drawer-content>
        </mat-drawer-container>
    } @else {
        <div class="flex column align-center justify-center">
            <mat-card appearance="outlined">
                <mat-card-content>
                    <img src="assets/missing_image.png" />
                    <h1>Permission Denied</h1>
                </mat-card-content>
            </mat-card>
        </div>
    }
}
